import schemaHelper from '@/components/profile/sections/tabs/financial/resources/schemaHelper';


export default { fields: schemaHelper.otherFields() };



// WEBPACK FOOTER //
// ./src/components/profile/sections/tabs/financial/assets/schemas/otherProperties.js